// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"306":"learner-dashboard-main","569":"instructor-dashboard-main"}[chunkId] || chunkId) + "." + {"306":"a0cbe01e628056fb5604","569":"8c93fddadb92905bd8bb","710":"b900e59142ac3fd67113"}[chunkId] + ".js";
};